import React from 'react';
import { CheckIcon, LockIcon, SnowflakeIcon } from 'lucide-react';
import { CHECKOUT_URL, offerIncludes, BRAND } from '../data/site';
import { usePricing } from '../hooks/usePricing';
import { BuyButton } from './ui/BuyButton';
interface OfferCardProps {
  showCountdown?: boolean;
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
}
export function OfferCard({
  showCountdown = true,
  countdown
}: OfferCardProps) {
  const {
    price,
    currency,
    loading
  } = usePricing();
  return <section id="oferta" className="w-full bg-sage-800 py-14 sm:py-20 lg:py-24" data-id="element-100" data-mp="1f82htz6m4vea">
      <div className="mx-auto max-w-4xl px-4 sm:px-8" data-id="element-101" data-mp="1af9bx7zerh0m">
        <div className="text-center" data-id="element-102" data-mp="1adpv9g9ub3yb">
          <p className="flex items-center justify-center gap-2.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-200 sm:gap-3 sm:text-[11px] sm:tracking-overline" data-id="element-103" data-mp="15hrdwcmxim7e">
            <SnowflakeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-104" data-mp="1y5wx2uyc4354" />
            Acceso inmediato
          </p>
          <h2 className="mt-4 font-serif text-[1.85rem] leading-[1.12] text-cream sm:mt-5 sm:text-[2.9rem] sm:leading-[1.06] lg:text-[3.4rem]" data-id="element-105" data-mp="8fje53a07mop">
            Esta Navidad crea algo especial{' '}
            <span className="italic text-gold-200" data-id="element-106" data-mp="3vtf2i4ieg5st">con tus propias manos</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[14.5px] leading-relaxed text-sage-100 sm:mt-6 sm:text-[17px]" data-id="element-107" data-mp="3oukpierkfmx">
            Accede ahora al manual completo + todos los bonus y descubre cómo
            crear esferas navideñas únicas para decorar, regalar o vender.
          </p>
        </div>

        {showCountdown ? <div className="mt-8 flex items-center justify-center gap-2.5 sm:mt-9 sm:gap-3" data-id="element-108" data-mp="3cut08mb5c8nb">
            {[{
          value: countdown.hours,
          label: 'Horas'
        }, {
          value: countdown.minutes,
          label: 'Min'
        }, {
          value: countdown.seconds,
          label: 'Seg'
        }].map(unit => <div key={unit.label} className="w-[66px] rounded-2xl border border-sage-700 bg-sage-900/60 py-2.5 text-center sm:w-[74px] sm:py-3" data-id="element-109" data-mp="1f2yikzoh2nx9">
                <p className="font-serif text-[1.5rem] leading-none text-gold-200 sm:text-[1.7rem]" data-id="element-110" data-mp="2j23hanul5158">
                  {unit.value}
                </p>
                <p className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-sage-200" data-id="element-111" data-mp="2f1ba0059x6bl">
                  {unit.label}
                </p>
              </div>)}
          </div> : null}

        <div className="mt-9 rounded-3xl bg-cream p-5 shadow-[0_40px_80px_-40px_rgba(0,0,0,0.65)] sm:mt-11 sm:rounded-4xl sm:p-9" data-id="element-112" data-mp="36qedhdpc6cn6">
          <div className="grid gap-6 sm:gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-center" data-id="element-113" data-mp="32s73r2taiblh">
            <img src={BRAND.ebookMockup} alt="Manual de Esferas Navideñas y bonus incluidos" className="mx-auto w-full max-w-[170px] object-contain drop-shadow-[0_26px_40px_rgba(14,35,21,0.3)] sm:max-w-[220px] lg:max-w-none" data-id="element-114" data-mp="2xx9ohe5f3605" />

            <div data-id="element-115" data-mp="3lp8d0ztvmxv8">
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-600 sm:text-[11px] sm:tracking-overline" data-id="element-116" data-mp="3lootxfshq3fm">
                Todo lo que incluye
              </p>
              <ul className="mt-4 space-y-2.5" data-id="element-117" data-mp="1ta7nk3aho6x">
                {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[14px] leading-snug text-ink sm:text-[14.5px]" data-id="element-118" data-mp="1vmxejfah2uj">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-sage-500" aria-hidden="true" data-id="element-119" data-mp="au8ba19tftoz" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-6 rounded-2xl border-2 border-gold-200/70 bg-bone px-4 py-6 text-center sm:mt-8 sm:rounded-3xl sm:px-6 sm:py-7" data-id="element-120" data-mp="ks4m0ryucmmk">
            <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-600 sm:text-[11px] sm:tracking-overline" data-id="element-121" data-mp="pjwfpbdan8gx">
              Precio final
            </p>
            {loading ? <div className="mx-auto mt-4 h-10 w-40 animate-pulse rounded-full bg-shell sm:h-11 sm:w-44" aria-label="Calculando precio" data-id="element-122" data-mp="yldrihjo4nzt" /> : <p className="mt-3 font-serif text-[2.4rem] font-semibold leading-none text-sage-900 sm:text-[3.4rem]" data-id="element-123" data-mp="13h2wx1idcz41">
                <span className="align-middle text-[1.15rem] font-medium tracking-wide text-ink-soft sm:text-[1.6rem]" data-id="element-124" data-mp="lutogmetrcfm">
                  {currency}{' '}
                </span>
                {price}
              </p>}
            <p className="mt-3 text-[12.5px] font-medium text-ink-light sm:text-[13px]" data-id="element-125" data-mp="umn7qglqn18w">
              Pago único · sin suscripciones
            </p>
          </div>

          <div className="mt-6 flex flex-col items-center gap-3 sm:mt-7" data-id="element-126" data-mp="6znifzfqbdma">
            <BuyButton size="xl" label="Quiero empezar a crear mis esferas" href={CHECKOUT_URL} className="w-full" data-id="element-127" data-mp="2xk2oym11mv7" />
            <p className="flex items-center gap-2 text-center text-[12px] font-medium text-ink-light sm:text-[12.5px]" data-id="element-128" data-mp="gtnt0gts5b2e">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-129" data-mp="1saxc328zy136" />
              Compra segura · acceso inmediato al descargar
            </p>
          </div>
        </div>
      </div>
    </section>;
}